import React from 'react';
import './index.less';
import Image from 'next/image';
import { imageTransform } from '@/shared/utils/utils';

const SupplierPaymentInfo = () => {
  const img = 'https://static.pietrastudio.com/public_large/file_uploads/ecc7630061747a2cde414ace5909104f.png';
  return (
    <div className="payments-container">
      <div className="payments-information">
        <span className="payments-information-title">Get Paid Right Away</span>
        <p className="payments-information-desc">
          No waiting for payments or dealing with net 20/30/60 terms. All supplier payments are processed within 1
          business day of the Creator paying.
        </p>
      </div>
      <div className="payments-image">
        <Image src={imageTransform(img, 'large')} fill alt="img" />
      </div>
    </div>
  );
};

export default SupplierPaymentInfo;
